export const API_ERROR_CODE_I18N_REASON_PLATFORM_ENVIRONMENT: Record<string, string> = {
  actor_id_invalid: "common.errors.apiCodeReasons.platformEnvironment.actorIdInvalid",
  allocation_invalid: "common.errors.apiCodeReasons.platformEnvironment.allocationInvalid",
  application_image_source_type_invalid:
    "common.errors.apiCodeReasons.platformEnvironment.applicationImageSourceTypeInvalid",
  asset_id_required: "common.errors.apiCodeReasons.platformEnvironment.assetIdRequired",
  asset_center_internal_token_missing:
    "common.errors.apiCodeReasons.platformEnvironment.assetCenterInternalTokenMissing",
  base_url_missing: "common.errors.apiCodeReasons.platformEnvironment.baseUrlMissing",
  body_invalid: "common.errors.apiCodeReasons.platformEnvironment.bodyInvalid",
  business_reference_internal_token_missing:
    "common.errors.apiCodeReasons.platformEnvironment.businessReferenceInternalTokenMissing",
  container_image_category_invalid:
    "common.errors.apiCodeReasons.platformEnvironment.containerImageCategoryInvalid",
  container_image_source_type_invalid:
    "common.errors.apiCodeReasons.platformEnvironment.containerImageSourceTypeInvalid",
  consumer_loop_failed: "common.errors.apiCodeReasons.platformEnvironment.consumerLoopFailed",
  contract_invalid: "common.errors.apiCodeReasons.platformEnvironment.contractInvalid",
  custom_image_source_type_invalid:
    "common.errors.apiCodeReasons.platformEnvironment.customImageSourceTypeInvalid",
  download_failed: "common.errors.apiCodeReasons.platformEnvironment.downloadFailed",
  enqueue_failed: "common.errors.apiCodeReasons.platformEnvironment.enqueueFailed",
  envelope_invalid: "common.errors.apiCodeReasons.platformEnvironment.envelopeInvalid",
  environment_admin_required:
    "common.errors.apiCodeReasons.platformEnvironment.environmentAdminRequired",
  event_type_unexpected: "common.errors.apiCodeReasons.platformEnvironment.eventTypeUnexpected",
  execution_fabric_base_url_missing:
    "common.errors.apiCodeReasons.platformEnvironment.executionFabricBaseUrlMissing",
  execution_fabric_request_failed:
    "common.errors.apiCodeReasons.platformEnvironment.executionFabricRequestFailed",
  execution_fabric_response_invalid:
    "common.errors.apiCodeReasons.platformEnvironment.executionFabricResponseInvalid",
  execution_fabric_upstream_rejected:
    "common.errors.apiCodeReasons.platformEnvironment.executionFabricUpstreamRejected",
  field_invalid: "common.errors.apiCodeReasons.platformEnvironment.fieldInvalid",
  frr_router_implementation_required:
    "common.errors.apiCodeReasons.platformEnvironment.frrRouterImplementationRequired",
  identity_lookup_failed: "common.errors.apiCodeReasons.platformEnvironment.identityLookupFailed",
  identity_payload_invalid:
    "common.errors.apiCodeReasons.platformEnvironment.identityPayloadInvalid",
  identity_user_id_missing:
    "common.errors.apiCodeReasons.platformEnvironment.identityUserIdMissing",
  image_usage_type_invalid:
    "common.errors.apiCodeReasons.platformEnvironment.imageUsageTypeInvalid",
  integration_not_configured:
    "common.errors.apiCodeReasons.platformEnvironment.integrationNotConfigured",
  invalid: "common.errors.apiCodeReasons.platformEnvironment.invalid",
  invalid_payload: "common.errors.apiCodeReasons.platformEnvironment.invalidPayload",
  inventory_request_failed:
    "common.errors.apiCodeReasons.platformEnvironment.inventoryRequestFailed",
  inventory_response_invalid:
    "common.errors.apiCodeReasons.platformEnvironment.inventoryResponseInvalid",
  inventory_upstream_rejected:
    "common.errors.apiCodeReasons.platformEnvironment.inventoryUpstreamRejected",
  metadata_reserved_key_forbidden:
    "common.errors.apiCodeReasons.platformEnvironment.metadataReservedKeyForbidden",
  name_required: "common.errors.apiCodeReasons.platformEnvironment.nameRequired",
  network_category_required:
    "common.errors.apiCodeReasons.platformEnvironment.networkCategoryRequired",
  outbox_claim_failed: "common.errors.apiCodeReasons.platformEnvironment.outboxClaimFailed",
  payload_invalid: "common.errors.apiCodeReasons.platformEnvironment.payloadInvalid",
  positive_integer_required:
    "common.errors.apiCodeReasons.platformEnvironment.positiveIntegerRequired",
  public_id_missing: "common.errors.apiCodeReasons.platformEnvironment.publicIdMissing",
  public_id_required: "common.errors.apiCodeReasons.platformEnvironment.publicIdRequired",
  publish_disabled: "common.errors.apiCodeReasons.platformEnvironment.publishDisabled",
  publish_failed: "common.errors.apiCodeReasons.platformEnvironment.publishFailed",
  published_status_transition_forbidden:
    "common.errors.apiCodeReasons.platformEnvironment.publishedStatusTransitionForbidden",
  queue_unavailable: "common.errors.apiCodeReasons.platformEnvironment.queueUnavailable",
  request_failed: "common.errors.apiCodeReasons.platformEnvironment.requestFailed",
  resource_not_found: "common.errors.apiCodeReasons.platformEnvironment.resourceNotFound",
  response_invalid: "common.errors.apiCodeReasons.platformEnvironment.responseInvalid",
  retryable_processing_failed:
    "common.errors.apiCodeReasons.platformEnvironment.retryableProcessingFailed",
  runtime_base_url_missing:
    "common.errors.apiCodeReasons.platformEnvironment.runtimeBaseUrlMissing",
  runtime_type_invalid: "common.errors.apiCodeReasons.platformEnvironment.runtimeTypeInvalid",
  sequence_exhausted: "common.errors.apiCodeReasons.platformEnvironment.sequenceExhausted",
  source_not_found: "common.errors.apiCodeReasons.platformEnvironment.sourceNotFound",
  source_service_unexpected:
    "common.errors.apiCodeReasons.platformEnvironment.sourceServiceUnexpected",
  sso_base_url_missing: "common.errors.apiCodeReasons.platformEnvironment.ssoBaseUrlMissing",
  status_invalid: "common.errors.apiCodeReasons.platformEnvironment.statusInvalid",
  stream_key_missing: "common.errors.apiCodeReasons.platformEnvironment.streamKeyMissing",
  system_core_role_required:
    "common.errors.apiCodeReasons.platformEnvironment.systemCoreRoleRequired",
  traffic_dependency_rejected:
    "common.errors.apiCodeReasons.platformEnvironment.trafficDependencyRejected",
  traffic_dependency_request_failed:
    "common.errors.apiCodeReasons.platformEnvironment.trafficDependencyRequestFailed",
  traffic_dependency_response_invalid:
    "common.errors.apiCodeReasons.platformEnvironment.trafficDependencyResponseInvalid",
  traffic_library_config_missing:
    "common.errors.apiCodeReasons.platformEnvironment.trafficLibraryConfigMissing",
  traffic_picker_request_invalid:
    "common.errors.apiCodeReasons.platformEnvironment.trafficPickerRequestInvalid",
  unsupported_kind: "common.errors.apiCodeReasons.platformEnvironment.unsupportedKind",
  upstream_rejected: "common.errors.apiCodeReasons.platformEnvironment.upstreamRejected",
  vm_disk_binding_forbidden:
    "common.errors.apiCodeReasons.platformEnvironment.vmDiskBindingForbidden",
};
